
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

const Statistics = () => {
  const [counts, setCounts] = useState({
    packages: 0,
    countries: 0,
    partners: 0,
    rating: 0,
  });

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    const targets = {
      packages: 2000000,
      countries: 50,
      partners: 500,
      rating: 4.9,
    };

    let step = 0;

    const timer = setInterval(() => {
      step++;
      const progress = step / steps;
      setCounts({
        packages: Math.floor(targets.packages * progress),
        countries: Math.floor(targets.countries * progress),
        partners: Math.floor(targets.partners * progress),
        rating: parseFloat((targets.rating * progress).toFixed(1)),
      });

      if (step >= steps) {
        clearInterval(timer);
        setCounts(targets);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  const stats = [
    {
      value: `${(counts.packages / 1000000).toFixed(1)}M+`,
      label: 'Packages Tracked',
      icon: 'ri-box-3-line',
      color: 'bg-primary-blue',
    },
    {
      value: `${counts.countries}+`,
      label: 'Countries',
      icon: 'ri-global-line',
      color: 'bg-primary-green',
    },
    {
      value: `${counts.partners}+`,
      label: 'Partners',
      icon: 'ri-team-line',
      color: 'bg-primary-blue',
    },
    {
      value: `${counts.rating}/5`,
      label: 'Customer Rating',
      icon: 'ri-star-fill',
      color: 'bg-primary-green',
    },
  ];

  return (
    <section className="py-24 bg-primary-navy relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center relative"
            >
              {index < stats.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 right-0 w-px h-16 bg-white/20 -translate-y-1/2"></div>
              )}
              <div className={`w-16 h-16 flex items-center justify-center ${stat.color} rounded-xl mx-auto mb-6`}>
                <i className={`${stat.icon} text-white text-3xl`}></i>
              </div>
              <div className="text-5xl lg:text-6xl font-bold text-white mb-3">{stat.value}</div>
              <div className="text-lg text-gray-400">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
